import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]

import DocPage from "../components/DocPage.vue";
import { company } from "../company";
import { useLocalePath } from "../composables/useLocalePath";


export default /*#__PURE__*/_defineComponent({
  __name: 'LegalNotice',
  setup(__props) {

const lp = useLocalePath();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(DocPage, {
    title: _ctx.$t('pages.legal.title'),
    lede: _ctx.$t('pages.legal.lede')
  }, {
    default: _withCtx(() => [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t("pages.legal.publisher")), 1),
      _createElementVNode("dl", null, [
        _createElementVNode("dt", null, _toDisplayString(_ctx.$t("pages.legal.fields.name")), 1),
        _createElementVNode("dd", null, _toDisplayString(_unref(company).legalName), 1),
        _createElementVNode("dt", null, _toDisplayString(_ctx.$t("pages.legal.fields.hosting")), 1),
        _createElementVNode("dd", null, _toDisplayString(_ctx.$t("pages.legal.hosting")), 1),
        _createElementVNode("dt", null, _toDisplayString(_ctx.$t("pages.legal.fields.email")), 1),
        _createElementVNode("dd", null, [
          _createElementVNode("a", {
            href: `mailto:${_unref(company).email}`
          }, _toDisplayString(_unref(company).email), 9, _hoisted_1)
        ])
      ]),
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t("pages.legal.ip.title")), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("pages.legal.ip.p1")), 1),
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t("pages.legal.data.title")), 1),
      _createElementVNode("p", null, [
        _createTextVNode(_toDisplayString(_ctx.$t("pages.legal.data.p1")) + " ", 1),
        _createVNode(_component_router_link, {
          to: _unref(lp)('/privacy')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("footer.privacy")), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createTextVNode(". ")
      ])
    ]),
    _: 1
  }, 8, ["title", "lede"]))
}
}

})